import type { FC } from 'react';

import { useMediaQuery } from '@react-hookz/web';
import { Form as FormikForm } from 'formik';
import styled, { css, useTheme } from 'styled-components';

import type { ButtonProps } from 'src/app/components/Elements/Button';
import ReusableButton from 'src/app/components/Elements/Button';
import ReusableSubmitButton from 'src/app/components/Elements/Button/Submit';
import { Typography } from 'src/app/components/Elements/Typography';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: ${({ theme }) => theme.space.s9} auto !important;
  width: calc(100vw - (${({ theme }) => theme.space.s6} * 2));
  max-width: 504px;
  min-height: 300px;
  gap: ${props => props.theme.space.s5} !important;

  & > h1,
  & > h2 {
    text-align: center;
  }

  &&& > * {
    margin: 0 auto !important;
  }

  &&& > *:last-child {
    margin-top: ${({ theme }) => theme.space.s5} !important;
    margin-bottom: ${({ theme }) => theme.space.s5} !important;
  }

  ${({ theme }) => theme.mediaQueries.smallDown} {
    min-height: 200px;
    margin: ${({ theme }) => theme.space.s7} auto !important;
  }
`;

export const Header: FC = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.smallDown);

  return <Typography variant={isMobile ? 'h2' : 'h1'}>{children}</Typography>;
};

const bottomButtonStyles = css`
  display: block;

  ${({ theme }) => theme.mediaQueries.smallDown} {
    width: 100%;
  }
`;

export const Description: FC = ({ children }) => {
  return <Typography variant="body">{children}</Typography>;
};

/**
 * Don't use this if a form is on the page.
 * Instead use AuthSubmitButton exported from same file.
 */
export const ContinueButton = styled(ReusableButton).attrs({
  children: 'Continue',
  type: 'button',
  size: 'medium',
  style: 'capsuleBlue50',
})`
  ${bottomButtonStyles}
` as FC<Required<Pick<ButtonProps, 'onClick'>>>;

export const Form = styled(FormikForm)`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${props => props.theme.space.s5} !important;

  & > *:not(:last-child) {
    width: 100%;
  }
`;

export const SubmitButton = styled(ReusableSubmitButton).attrs({ style: 'capsuleBlue50', size: 'medium' })`
  ${bottomButtonStyles}
`;
